import { DocumentationContainer } from './container';

export const DocumentationRoute = DocumentationContainer;
